import { colorOf } from "@/lib/colors";
import { todayIso } from "@/lib/dates";
import { GridCell } from "./GridCell";
import { EmployeeAvatar } from "./EmployeeBadge";

const RowHead = ({ employee, count }) => {
  const c = colorOf(employee);
  return (
    <div
      data-testid={`row-head-${employee.id}`}
      className="row-head sticky left-0 z-10"
      style={{ background: c.bg, borderColor: c.border, boxShadow: `inset 4px 0 0 ${c.accent}` }}
    >
      <EmployeeAvatar employee={employee} />
      <div className="min-w-0 flex-1">
        <p className="truncate font-display text-sm font-semibold" style={{ color: c.ink }}>{employee.name}</p>
        <p className="truncate text-[11px] text-slate-500">{employee.role || `${count} attività`}</p>
      </div>
    </div>
  );
};

export const WeekGrid = ({ days, employees, tasksFor, h }) => {
  const today = todayIso();
  const style = {
    gridTemplateColumns: `150px repeat(${days.length}, minmax(160px, 1fr))`,
    minWidth: 150 + days.length * 160,
  };

  return (
    <div data-testid="week-grid" className="planner-surface overflow-x-auto">
      <div className="grid" style={style}>
        <div className="grid-head sticky left-0 z-20 text-xs uppercase tracking-wider text-slate-500">Dipendenti</div>
        {days.map((d) => (
          <div key={d.iso} data-testid={`day-header-${d.idx}`} className={`grid-head ${d.iso === today ? "is-today" : ""}`}>
            <span className="font-display text-sm font-semibold">{d.name}</span>
            <span className="text-xs text-slate-500">{d.label}</span>
          </div>
        ))}
        {employees.map((emp) => (
          <Row key={emp.id} emp={emp} days={days} today={today} tasksFor={tasksFor} h={h} />
        ))}
      </div>
    </div>
  );
};

const Row = ({ emp, days, today, tasksFor, h }) => {
  const c = colorOf(emp);
  const count = days.reduce((n, d) => n + tasksFor(emp.id, d.iso).length, 0);
  return (
    <>
      <RowHead employee={emp} count={count} />
      {days.map((d) => (
        <GridCell key={d.iso} employee={emp} day={d} tasks={tasksFor(emp.id, d.iso)} color={c} isToday={d.iso === today} h={h} />
      ))}
    </>
  );
};
